import { useMemo } from 'react';
import { useField } from 'react-final-form';

import { type FWorkflowStepDefinitionFragment } from '@dashboard/generated/wp/platform';
import { getWorkflowStepDefinitionType } from '@dashboard/models/WorkflowStepDefinition';

export default function useWorkflowStepField(name: string) {
  return useField<FWorkflowStepDefinitionFragment>(name);
}

export function useWorkflowStepType(name: string) {
  const {
    input: { value },
  } = useWorkflowStepField(name);
  return useMemo(() => getWorkflowStepDefinitionType(value), [value]);
}
